export default __webpack_public_path__ + "static/media/music-spider.69cf6861.png";